export default "__VITE_ASSET__X0yO10ze__"